import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeyService {

  private readonly key!: string;

  constructor() { 
    this.key =  Date.now().toString();
  }

  getKey(): string {
    return this.key;
  }
}
